<template>
    <v-app id="Gbmt4">
        <v-main>
            <v-container fluid>
                <v-row>
                    <v-col cols="1">
                        <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select v-model="param.typeCode" :items="param.typeCodes" item-value="typeCode"  item-text="typeCodeOms" label="Type of list"></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="1">
                        <v-select v-model="param.jaarCode" :items="jaarSelect" item-value="value"  item-text="text" label="Year"></v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-select v-model="param.periodeVanCode" :items="periodeVanSelect" item-value="value"  item-text="text" label="Period from"></v-select>
                    </v-col>
                    <v-col cols="1">
                        <v-select v-model="param.periodeTmCode" :items="periodeTmSelect" item-value="value"  item-text="text" label="Period until"></v-select>
                    </v-col>
                </v-row>
                <v-row>    
                    <v-col cols="1">
                        <v-btn class="primary ma-0" small :disabled="submitted||param.typeCode===''" @click="ovrz">Create excel</v-btn>
                    </v-col> 
                </v-row>
            </v-container>
        </v-main>
        <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
    </v-app>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
 
    export default {
        components: {
            navBar
        },
        data() {
            return {
                jaarSelect: [],
                periodeVanSelect: [],
                periodeTmSelect: [],
                bedrCodesSelected: [],
                bedrCodes: [],
                // dat1menu: false,
                // dat2menu: false,
                // hulpDate: '',
                submitted: false,
                param: {
                    typeCode: "",
                    typeCodes: [],
                    jaarCode : 0,
                    jaarCodes : [],
                    periodeVanCode : 0,
                    periodeVanCodes : [],
                    periodeTmCode : 0,
                    periodeTmCodes : [],
                }
            }
        },
        mounted() {
            this.getGbmt4Param();
        },
        methods: {
            getGbmt4Param() {
                var deze = this;
                this.$axios.post("ares/json/ares/task/fin/exact/getGbmt4Param.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getGbmt4Param"
                    },
                    getGbmt4Param: {}
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.param = res.data.getGbmt4Param; 
                            res.data.getGbmt4Param.bedrKeuzes.forEach(function(bedr) {
                            deze.bedrCodes.push(bedr.bedrCode);
                            if (bedr.bedrSelected === true) {
                                deze.bedrCodesSelected.push(bedr.bedrCode);
                            }
                        });
                        for (let iIndex=0;iIndex<this.param.jaarCodes.length;iIndex++) {
                            this.jaarSelect.push({
                                value: this.param.jaarCodes[iIndex],
                                text: String(this.param.jaarCodes[iIndex])
                            })
                        }
                        for (let iIndex=0;iIndex<this.param.periodeVanCodes.length;iIndex++) {
                            this.periodeVanSelect.push({
                                value: this.param.periodeVanCodes[iIndex],
                                text: String(this.param.periodeVanCodes[iIndex])
                            })
                        }
                        for (let iIndex=0;iIndex<this.param.periodeTmCodes.length;iIndex++) {
                            this.periodeTmSelect.push({
                                value: this.param.periodeTmCodes[iIndex],
                                text: String(this.param.periodeTmCodes[iIndex])
                            })
                        }
                    }
                });
            },

            ovrz() {
                this.results = true;
                this.submitted = true;
                this.$axios.post("ares/json/ares/task/fin/exact/excelExportGbmt4.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportGbmt4"
                    },
                    excelExportGbmt4: {
                        bedr_codes: this.bedrCodesSelected,
                        jaar: this.param.jaarCode,
                        periode_van: this.param.periodeVanCode,
                        periode_tm: this.param.periodeTmCode,
                        type_lijst_finance: this.param.typeCode,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.submitted = false;
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.excelExportGbmt4.text,
                            color: res.data.excelExportGbmt4.color,
                        });
                    }
                })
            },
        }
    };
</script> 
